// extracted by mini-css-extract-plugin
module.exports = {"termsNConditionsContent":"TermsNConditionsPage_termsNConditionsContent__2iuyX","textJustify":"TermsNConditionsPage_textJustify__1H3jE"};